<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary" class="elevation-0">
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <template v-if="!_currentDocument.id">
            {{ _currentDocument.title }}
          </template>
          <template v-else>
            {{ _currentDocument.title }} № {{ _currentDocument.id}}
          </template>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            v-if="$vuetify.breakpoint.xsOnly"
            flat
            icon
            small
            :loading="_isSaving"
            @click.native="$emit('saveDocument')"
            :disabled="!_currentDocument.records.length"
          >
            <v-icon left>mdi-content-save</v-icon>
          </v-btn>
          <v-btn
            v-else
            flat
            :loading="_isSaving"
            @click.native="$emit('saveDocument')"
            :disabled="!_currentDocument.records.length"
          >
            <v-icon left>mdi-content-save</v-icon>
            Сохранить
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <component
        :is="catalogDocumentComponent"
        @openOptionsDialog="openOptionsDialog"
        :documentTypes="documentTypes"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mapMultiRowFields, mapFields } from 'vuex-map-fields'
import CatalogDocumentTable from './CatalogDocumentTable'
import CatalogDocumentList from './CatalogDocumentList'

export default {
  name: 'catalog-documents-modal',
  components: {
    CatalogDocumentTable,
    CatalogDocumentList
  },
  data () {
    return {
      dialog: false,
      documentTypes: {
        rezervirovanie: {
          headers: [
            {
              sortable: false,
              width: '60px'
            },
            {
              text: 'Код',
              align: 'right',
              width: '90px',
              value: 'nomenklatura_id'
            },
            {
              text: 'Наименование',
              align: 'left',
              value: 'name'
            },
            {
              text: 'К-во',
              align: 'right',
              width: '100px',
              value: 'kolichestvo'
            },
            {
              text: 'Резерв',
              align: 'right',
              width: '100px',
              value: 'rezerv'
            },
            {
              text: 'Цена',
              width: '120px',
              align: 'right',
              value: 'tsena'
            },
            {
              text: 'Текущая сумма',
              width: '120px',
              align: 'right',
              value: 'summa'
            },
            {
              text: 'Предпологаемая сумма',
              width: '120px',
              align: 'right',
              value: 'summa'
            },
            {
              text: '',
              align: 'center',
              width: '45px',
              value: 'actions',
              sortable: false
            }
          ]
        },
        schet: {
          headers: [
            {
              sortable: false,
              width: '60px'
            },
            {
              text: 'Код',
              align: 'right',
              width: '100px',
              value: 'nomenklatura_id'
            },
            {
              text: 'Наименование',
              align: 'left',
              value: 'name'
            },
            {
              text: 'К-во',
              align: 'right',
              width: '100px',
              value: 'kolichestvo'
            },
            {
              text: 'Резерв',
              align: 'right',
              width: '100px',
              value: 'rezerv'
            },
            {
              text: 'Цена с НДС',
              width: '120px',
              align: 'right',
              value: 'tsena'
            },
            {
              text: 'Текущая сумма',
              width: '120px',
              align: 'right',
              value: 'summa'
            },
            {
              text: 'Предпологаемая сумма',
              width: '120px',
              align: 'right',
              value: 'summa'
            },
            {
              text: '',
              align: 'center',
              width: '45px',
              value: 'actions',
              sortable: false
            }
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _currentDocument: 'currentDocument'
    }),
    ...mapMultiRowFields('catalog', {
      _records: 'currentDocument.records'
    }),
    ...mapFields('catalog', {
      _isSaving: 'isSaving'
    }),
    catalogDocumentComponent () {
      return this.$vuetify.breakpoint.smAndDown ? 'catalog-document-list' : 'catalog-document-table'
    }
  },
  methods: {
    ...mapActions('catalog', {
      _deleteRow: 'deleteRow',
      _refreshItemsTableQuantity: 'refreshItemsTableQuantity'
    }),
    open () {
      this.dialog = true
    },
    openOptionsDialog (item) {
      this.$emit('openOptionsDialog', item)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .v-toolbar__title {
    @media screen and (max-width: 599px) {
      font-size 14px
      margin-left: 0
    }
  }
</style>
